<template>
  <van-row justify="center" class="page-wrapper have-bottom-menu">
    <van-col
      span="24"
      class="itserve-center place-content-center flex-display-fix"
    >
      <KharkivGasSendIndication />
    </van-col>
  </van-row>
</template>
<script>
import KharkivGasSendIndication from "@/components/contacts/KharkivGasSendIndication";
export default {
  name: "ContactRegionalEnergy",
  components: { KharkivGasSendIndication },
};
</script>
